export enum PlatformType {
  Android,
  iOS,
  Other,
}

export enum OSPlatform {
  android = 'android',
  ios = 'ios',
  web = 'web',
}

export interface IDevice {
  token: string;
  platform: PlatformType;
}
